/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ChangeIdentityVerificationScheduledDate200Response
 */
export interface ChangeIdentityVerificationScheduledDate200Response {
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'isApprovalFeatureEnabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'pointBalance': number;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'guaranteeMoneyBalance': number;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'availableLimit': number;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'creditLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'creditSettlement': number | null;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'creditUsage': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'isVCCooperationPlanEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'paymentScheme': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'identityVerificationScheduledDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'externalAccountTransferAgency': ChangeIdentityVerificationScheduledDate200ResponseExternalAccountTransferAgencyEnum;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'cardCountLimit': number;
}

export const ChangeIdentityVerificationScheduledDate200ResponseExternalAccountTransferAgencyEnum = {
    moneyForwardKessai: 'MONEY_FORWARD_KESSAI',
    ufj: 'UFJ'
} as const;

export type ChangeIdentityVerificationScheduledDate200ResponseExternalAccountTransferAgencyEnum = typeof ChangeIdentityVerificationScheduledDate200ResponseExternalAccountTransferAgencyEnum[keyof typeof ChangeIdentityVerificationScheduledDate200ResponseExternalAccountTransferAgencyEnum];


